<template>
  <div class="permission-tree">
    <div v-if="!ready" class="text-center p-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div v-else-if="filteredCategories.length === 0" class="text-center p-4 text-muted">
      No permissions available for this user type.
    </div>

    <div v-else>
      <div
        v-for="cat in filteredCategories"
        :key="cat.id"
        class="perm-category my-3"
      >
        <h5>{{ cat.name }}</h5>

        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Permission</th>
              <th style="width:700px">Access</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="item in cat.items" :key="item.id">
              <td>{{ item.name }}</td>
              <td>
                <access-level-select
                  :model-value="localSelected[item.id] || 'N'"
                  :user-type="userType"
                  :id="item.id"
                  @update:modelValue="onChange(item.id, $event)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import AccessLevelSelect from "./AccessLevelSelect.vue";

export default {
  components: { AccessLevelSelect },

  props: {
    categories: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Object,
      required: true
    },
    userTypePermissions: {
      type: Array,
      default: () => []
    },
    userType: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      localSelected: {},
      ready: false
    };
  },

  watch: {
    selected: {
      immediate: true,
      deep: true,
      handler(newVal) {
        console.log("Selected prop changed:", newVal);
        this.localSelected = { ...newVal };
        this.ready = true;
      }
    },

    userTypePermissions: {
      immediate: true,
      handler(newVal) {
        console.log("UserTypePermissions changed:", newVal);
        // Ensure we only keep permissions that are in userTypePermissions
        const allowedIds = newVal.map(p => p.id);
        const filtered = {};

        Object.keys(this.localSelected).forEach(key => {
          const permId = Number(key);
          if (allowedIds.includes(permId)) {
            filtered[permId] = this.localSelected[key];
          }
        });

        this.localSelected = filtered;
        this.ready = true;
      }
    }
  },

  computed: {
    filteredCategories() {
      if (!Array.isArray(this.userTypePermissions) || this.userTypePermissions.length === 0) {
        return [];
      }

      const allowedIds = this.userTypePermissions.map(p => p.id);

      // Transform categories with filtered items
      const result = this.categories
        .map(category => {
          if (!category || !Array.isArray(category.items)) {
            return null;
          }

          const filteredItems = category.items.filter(item =>
            item && item.id && allowedIds.includes(item.id)
          );

          if (filteredItems.length === 0) {
            return null;
          }

          return {
            ...category,
            items: filteredItems.sort((a, b) => a.order - b.order)
          };
        })
        .filter(category => category !== null);

      console.log("Filtered Categories:", result);
      return result;
    }
  },

  methods: {
    onChange(permissionId, level) {
      // Update the local selected object
      const updated = { ...this.localSelected };

      if (level === "N") {
        delete updated[permissionId];
      } else {
        updated[permissionId] = level;
      }

      this.localSelected = updated;

      // Emit the change to parent
      this.$emit("update", {
        id: permissionId,
        level
      });
    }
  }
};
</script>


<!--<template>-->
<!--  <div class="permission-tree">-->
<!--    <div v-for="cat in filteredCategories" :key="cat.id" class="perm-category my-3">-->
<!--      <h5>{{ cat.name }}</h5>-->

<!--      <table class="table table-sm table-bordered">-->
<!--        <thead>-->
<!--          <tr>-->
<!--            <th>Permission</th>-->
<!--            <th style="width:700px">Access</th>-->
<!--          </tr>-->
<!--        </thead>-->

<!--        <tbody>-->
<!--          <tr v-for="item in cat.items" :key="item.id">-->
<!--            <td>{{ item.name }}</td>-->
<!--            <td>-->
<!--              <access-level-select-->
<!--                v-model="selected[item.id]"-->
<!--                :user-type="userType"-->
<!--              />-->
<!--            </td>-->
<!--          </tr>-->
<!--        </tbody>-->
<!--      </table>-->
<!--    </div>-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import AccessLevelSelect from "./AccessLevelSelect.vue";-->

<!--export default {-->
<!--  props: {-->
<!--    categories: { type: Array, default: () => [] },-->
<!--    selected: { type: Object, default: () => ({}) },-->
<!--    userTypePermissions: { type: Array, default: () => [] },-->
<!--    currentUserTypeId: { type: Number, default: null },-->
<!--    userType: {-->
<!--      type: [String],-->
<!--      default: null-->
<!--    }-->
<!--  },-->
<!--  components: { AccessLevelSelect },-->

<!--  computed: {-->
<!--    filteredCategories() {-->
<!--      const allowedIds = this.userTypePermissions.map(p => p.id);-->
<!--      return this.categories-->
<!--        .map(cat => {-->
<!--          const items = Array.isArray(cat.items) ? cat.items : [];-->
<!--          const filteredItems = items.filter(item => allowedIds.includes(item.id));-->
<!--          return { ...cat, items: filteredItems };-->
<!--        })-->
<!--        .filter(cat => cat.items.length > 0);-->
<!--    }-->
<!--  },-->

<!--  methods: {-->
<!--    updatePermission(payload) {-->
<!--      this.$emit("update", payload);-->
<!--    }-->
<!--  }-->
<!--};-->
<!--</script>-->
